jQuery(function($){
  //category carousel
$('.category-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    responsive:{
        0:{
            items:1,
            margin:10
        },
        600:{
            items:3,
            margin:20
        },
        1000:{
            items:4,
            margin:30,
            nav:true
        }
    }
})
//category carousel
//home new tab sec

  
 $(".tab_drawer_heading").click(function() {

     $(".tab_content").hide();
     var d_activeTab = $(this).attr("rel");
     $("#"+d_activeTab).fadeIn();

   $(".tab_drawer_heading").removeClass("d_active");
     $(this).addClass("d_active");

   $("ul.tabs li").removeClass("active");
   $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
   });

 $('ul.tabs li').last().addClass("tab_last");
 //home new tab sec
 //home new carousel

$(window).on('load',function(){

  $('.home-new-carousel').owlCarousel({

      loop:true,
      margin:10,
      nav:true,
      responsive:{
          0:{
              items:1,
              margin:10
          },
          600:{
              items:3,
              margin:20
          },
          1000:{
              items:4,
              margin:30,
              nav:true
          }
      }
  });

});
 //home new carousel

//desktop slider
$('#example1').accordionSlider({
  width:'100%',
  height:674,
  openedPanelSize:'70%',
  responsiveMode: 'auto',
  visiblePanels:4,
  closePanelsOnMouseOut: false,
  autoplay:false,
  mouseWheel: false, openPanelOn: 'click', maxOpenedPanelSize:'100%',
  shadow:false,
});

//mobile slider
$('.collection-slider-mob').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
});


});